import React, { Component } from 'react';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Form, InputGroup } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import MediaQuery from 'react-responsive';

let searchInputValue = '';

const options = {
    sizePerPage: 20,
    hideSizePerPage: true,
};

const MySearch = (props) => {
    let input;
    const handleClick = () => {
        props.onSearch(input.value);
        searchInputValue = input.value;
    };
    return (
        <div>
            <InputGroup size="sm" className="mb-3">
                {/* <InputGroup.Text id="basic-addon1">
                    <i className="fa fa-search"></i>
                </InputGroup.Text> */}
                <Form.Control size="sm" type="text" placeholder="Search" value={searchInputValue} onChange={handleClick} ref={n => input = n} />
            </InputGroup>
        </div>
    );
};

const mobileColumns = [
    {
        dataField: "ticker",
        text: "Ticker",
        sort: true,
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "price",
        text: "Price",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) }</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
    {
        dataField: "changesPercentage",
        text: "Change %",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) } %</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
    {
        dataField: "changes",
        text: "Changes",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) }</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    }
];

const columns = [
    {
        dataField: "ticker",
        text: "Ticker",
        sort: true,
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "companyName",
        text: "Name",
        sort: true,
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "price",
        text: "Price",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) }</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
    {
        dataField: "changesPercentage",
        text: "Change %",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) } %</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
    {
        dataField: "changes",
        text: "Change",
        sort: true,
        headerStyle: { fontSize: '10px' },
        formatter:  (cell, row) => {
            return(<>{ parseFloat(cell).toFixed(2) }</>)
        },
        style: (cell, row, rowIndex, colIndex) => {
            const style = {};
            if (row.changesPercentage > 0) {
                style.color = 'green';
            } else {
                style.color = 'red';
            }
            style.textAlign = 'right';
            style.fontWeight = 'bold';
            return style;
        }
    },
];

const rowStyle = (row, rowIndex) => {
    const style = {};
    // if (row.changesPercentage > 0) {
    //     style.backgroundColor = '#99cc99';
    // } else {
    //     style.color = 'red';
    // }
    style.fontSize = '10px';
    style.textAlign = 'right';
    return style;
};

class LoosersListDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            reload: false,
            columns: columns,
            mobileColumns: mobileColumns,
            searchInputValue: ''
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.interval = setInterval(() => { this.getData() }, 1000 * 10 * 1); //1 mins
        this.getData();
    }

    changeHidden = () => {
        let screenWidth = window.screen.width;
        const newColumns = this.state.columns.map((column) => {
            if (screenWidth < 500) {
                if (column.dataField === 'name' || column.dataField === 'dayLow' || column.dataField === 'dayHigh' || column.dataField === 'open') {
                    column.hidden = true;
                }
            } else {
                column.hidden = false;
            }
            return column;
        });
        this.setState({ columns: newColumns, reload: true });
    }

    getData() {
        ApiService.getLoosers()
            .then(result => {
                console.log('LoosersListDisplay', result);
                result.sort(this.custom_sort);
                this.setState({ dataList: result });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    custom_sort(a, b) {
        let aChange = parseFloat(a.changesPercentage);
        let bChange = parseFloat(b.changesPercentage);

        if (aChange > bChange) { return 1; }
        if (aChange < bChange) { return -1; }
        return 0;
        // if (a.changesPercentage > b.changesPercentage) { return -1; }
        // if (a.changesPercentage < b.changesPercentage) { return 1; }
        // return 0;
    }

    render() {
        // if (this.state.reload) {
        //     console.log('CryptoListDisplay Reloading...');
        //     this.setState({ reload: false });
        //     return (<div>Loading...</div>);
        // }
        return (
            <>
                <MediaQuery minWidth={501}>
                    <ToolkitProvider
                        keyField="symbol"
                        data={this.state.dataList}
                        columns={this.state.columns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <MySearch {...props.searchProps} />
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        hover
                                        striped
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>

                <MediaQuery maxWidth={500}>
                    <ToolkitProvider
                        keyField="symbol"
                        data={this.state.dataList}
                        columns={this.state.mobileColumns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <MySearch {...props.searchProps} />
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        hover
                                        striped
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>
            </>
        );
    }
}

export default LoosersListDisplay;
